import * as React from "react";
const SvgGrips = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.202 1.685a.5.5 0 0 0-.24.665l.314.67L3.414 9.95a.75.75 0 0 0 .67 1.342l6.543-3.27v9.09l-5.73 4.775a.75.75 0 0 0 .96 1.152l4.77-3.974v2.398a.75.75 0 0 0 1.5 0v-2.398l4.77 3.974a.75.75 0 0 0 .96-1.152l-5.73-4.775v-9.84l5.788-2.895.323.688a.5.5 0 0 0 .665.24l1.81-.85a.5.5 0 0 0 .24-.666l-1.276-2.715a.5.5 0 0 0-.665-.24l-1.81.851Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgGrips;
